<template>
  <div id="userRootGroupMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>分组管理</el-breadcrumb-item>
          <el-breadcrumb-item>所有分组</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="demo-form-inline">
        <el-form-item label="分组名称::">
          <el-input placeholder="请输入分组名称"
                    v-model="fGrpNameQuery"
                    class="input-with-select">
            <!--<el-button slot="append" icon="el-icon-search" @click="bindQuery"></el-button>-->
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="grpQuery">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right">
          <el-button type="primary"
                     size="small"
                     @click="addGroup"
                     v-if="is_edit&&is_admin">新增分组</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row style="padding-top: 10px">
      <el-table :data="groupList"
                highlight-current-row
                border
                style="width: 100%;overflow-y: auto"
                :height="groupListheight"
                ref="singleTable"
                @current-change="groupCurrentChange">
        <el-table-column type="index"
                         label="序号"
                         align="right"
                         :index="indexMethod"
                         width="50">
        </el-table-column>
        <el-table-column prop="fGrpNo"
                         width="80"
                         label="分组编号">
        </el-table-column>
        <el-table-column prop="fGrpName"
                         label="分组名称">
        </el-table-column>
        <el-table-column prop="fCustNum"
                         width="100"
                         align="right"
                         label="客户数量">
        </el-table-column>
        <el-table-column fixed="right"
                         width="240"
                         label="操作"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.fIsAllCust!='1'">
              <el-button @click="viewGroup(scope.$index, scope.row)"
                         type="success"
                         style="background-color:#5bc0de;border-color:#5bc0de"
                         size="mini">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         @click="editUIGroup(scope.$index, scope.row)"
                         v-if="is_edit&&is_admin">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="deleteGroup(scope.$index, scope.row)"
                         v-if="is_del&&is_admin">删除</el-button>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row style="padding-top: 20px">
      <group-per-and-park :grpInfoList="grpInfoList"
                          :grpParkList="grpParkList"
                          :childTableHeight="childTableHeight"></group-per-and-park>
    </el-row>
    <el-row>
      <div class="rootGroupEdit">
        <el-dialog :title="titleMap[form.operateFlag]"
                   v-dialogDrag
                   :visible.sync="dialogFormVisible"
                   top="7vh"
                   left="0vh">
          <el-form :model="form"
                   :rules="rules"
                   ref="rootEditform">
            <el-form-item label="分组编号::"
                          :label-width="formLabelWidth"
                          style="padding-bottom: 10px"
                          prop="fGrpNo">
              <el-input v-model="form.fGrpNo"
                        autocomplete="off"
                        :disabled="!canEditGrpNo"></el-input>
            </el-form-item>
            <el-form-item label="分组名称::"
                          :label-width="formLabelWidth"
                          style="padding-bottom: 2px;margin-top: 10px"
                          prop="fGrpName">
              <el-input v-model="form.fGrpName"
                        autocomplete="off"
                        :disabled="!isEdit"></el-input>
            </el-form-item>
            <!-- <el-form-item label="客户名称::" :label-width="formLabelWidth">
          <el-select v-model="form.selectCust" @change="getCustSelected">
            <el-option v-for="item in custList" :value="item.fCustID" :label="item.fCustName" :key="item.fCustID">{{item.fCustName}}</el-option>
          </el-select>
        </el-form-item> -->
            <el-tabs type="border-card"
                     style="margin-top: 20px">
              <el-tab-pane style="width: 100%;height: 371px">
                <span slot="label"><i class="el-icon-setting"></i> 基本信息</span>
                <fieldset v-for="(e,i) in perGroup"
                          :key="i">
                  <legend>{{e.name}}</legend>
                  <el-row class="check-group"
                          v-for="(item, index) in allPers.filter((per)=>{if(per.fPersIdx===e.fPersIdx){return per}})"
                          :key="index">
                    <el-col :span="6"
                            align="right"
                            style="padding-right: 20px;">{{item.fModName}}::</el-col>
                    <el-col :span="18">
                      <el-checkbox :disabled="!isEdit"
                                   v-model="item.allChecked"
                                   @change="persChange($event,item.fPersTypeID)">全选</el-checkbox>
                      <el-checkbox v-for="(data) in allChildPers.filter((childPer) => { if (childPer.fPersTypeID === item.fPersTypeID) { return childPer } })"
                                   :label="data.fPersID"
                                   :key="data.fPersName"
                                   v-model="data.myChecked"
                                   @change="checkChange($event,item,data.fPersTypeID)"
                                   :disabled="data.mydisable ||!isEdit">
                        {{data.fPersName}}
                      </el-checkbox>
                    </el-col>
                  </el-row>
                </fieldset>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"><i class="el-icon-news"></i> 绑定客户</span>
                <el-row style="padding-bottom: 10px">
                  <el-col :span="10">
                    <el-input placeholder="请输入客户编号或名称"
                              v-model="bindQueryInput"
                              class="input-with-select">
                      <el-button slot="append"
                                 icon="el-icon-search"
                                 @click="bindQuery"></el-button>
                    </el-input>
                  </el-col>
                  <el-col :span="4">&nbsp;</el-col>
                  <el-col :span="10">
                    <el-input placeholder="请输入客户编号或名称"
                              v-model="unbindQueryInput"
                              class="input-with-select">
                      <el-button slot="append"
                                 icon="el-icon-search"
                                 @click="unbindQuery"></el-button>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-table :data="form.bindCusts"
                              border
                              style="width: 100%;height: 350px"
                              height="350"
                              highlight-current-row
                              @current-change="bindParkChange">
                      <el-table-column type="index"
                                       label="序号"
                                       width="50">
                      </el-table-column>
                      <el-table-column prop="unionName"
                                       label="绑定客户">
                      </el-table-column>
                    </el-table>
                  </el-col>
                  <el-col :span="4"
                          style="text-align: center;">
                    <el-row style="padding-top: 60px">
                      <el-col :span="24">
                        <el-button type="primary"
                                   icon="el-icon-d-arrow-left"
                                   style="width: 100px"
                                   @click="leftAllBtnClick"
                                   v-if="is_bind"
                                   :disabled="!isEdit"></el-button>
                      </el-col>
                    </el-row>
                    <el-row style="padding-top: 20px">
                      <el-col :span="24">
                        <el-button type="primary"
                                   icon="el-icon-arrow-left"
                                   style="width: 100px"
                                   @click="leftBtnClick"
                                   v-if="is_bind"
                                   :disabled="!isEdit"></el-button>
                      </el-col>
                    </el-row>
                    <el-row style="padding-top: 20px">
                      <el-col :span="24">
                        <el-button type="primary"
                                   icon="el-icon-arrow-right"
                                   style="width: 100px"
                                   @click="rightBtnClick"
                                   v-if="is_bind"
                                   :disabled="!isEdit"></el-button>
                      </el-col>
                    </el-row>
                    <el-row style="padding-top: 20px">
                      <el-col :span="24">
                        <el-button type="primary"
                                   icon="el-icon-d-arrow-right"
                                   style="width: 100px"
                                   @click="rightAllBtnClick"
                                   v-if="is_bind"
                                   :disabled="!isEdit"></el-button>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="10">
                    <el-table :data="unbindCusts"
                              border
                              style="width: 100%;height: 350px"
                              height="350"
                              highlight-current-row
                              @current-change="unbindCustChange">
                      <el-table-column type="index"
                                       label="序号"
                                       width="50">
                      </el-table-column>
                      <el-table-column prop="unionName"
                                       label="可选客户">
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button type="primary"
                       @click="submitForm('rootEditform')"
                       v-if="isEdit">保存</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import groupPerAndPark from '../../components/groupPerAndPark'
export default {
  name: 'userRootGroupMain',
  components: { groupPerAndPark },
  data () {
    var checkfGrpNo = (rule, value, callback) => {
      if (this.canEditGrpNo) {
        let reg = new RegExp('^([0-9]|[0-9]){2}$')
        if (!reg.test(value)) {
          callback(new Error('组编号为2位数字'))
        }
      }
      callback()
    }
    return {
      is_edit: false,
      is_admin: false,
      is_del: false,
      is_bind: false,
      is_reset: false,
      canEditGrpNo: true,
      myFuck: 'aaa',
      checkPers: [],
      allChildPers: [],
      perGroup: [],
      allPers: [{
        fPersTypeID: 30000,
        fModName: '月卡管理::',
        pers: [{
          fPersID: 30010,
          fPersName: '查看权限',
          checked: false
        }, {
          fPersID: 30020,
          fPersName: '编辑权限',
          checked: true
        }, {
          fPersID: 30030,
          fPersName: '删除权限',
          checked: false
        }, {
          fPersID: 30040,
          fPersName: '导出权限',
          checked: true
        }
        ]
      }],
      isEdit: false,
      fGrpNameQuery: '',
      groupListheight: 0,
      childTableHeight: 0,
      grpInfoList: [],
      grpParkList: [],
      rightCust: {},
      leftCust: {},
      form: {
        fGrpID: '',
        fPGrpID: '',
        fLevel: '1',
        fGrpNo: '',
        fGrpName: '',
        operateFlag: '',
        bindCusts: [],
        bindCustsUI: [],
        fIsAdmin: 1
      },
      groupList: [],
      dialogFormVisible: false,
      titleMap: {
        add: '新增分组',
        edit: '编辑分组',
        view: '查看分组'
      },
      // isVisableCreateGrp: false,
      currentRow: null,
      formLabelWidth: '120px',
      unbindQueryInput: '',
      bindQueryInput: '',
      unbindCusts: [],
      unbindCustsUI: [],
      rules: {
        fGrpName: [
          { required: true, message: '请输入组名称(组名不能为空)', trigger: 'blur' },
          { min: 1, max: 59, message: '长度在 1 到 59 个字符', trigger: 'blur' }
        ],
        fGrpNo: [
          { required: true, message: '请输入组编号', trigger: 'blur' },
          { validator: checkfGrpNo, trigger: 'blur' }]
      },
      pageSize: 10,
      pageNo: 1,
      total: 0
    }
  },
  watch: {
    currentRow: function (val) {
      this.refreshUI(val)
    },
    groupListheight: function (val) {
      this.groupListheight = val
    },
    childTableHeight: function (val) {
      this.childTableHeight = val
    }
  },
  computed: {
    ...mapState({
      curUserPerAndParks: state => state.user.curUserPerAndParks,
      groupEdit: true, // state => state.user.curUserPerAndParks.pers['10020'] && state.user.curUserPerAndParks.pers['10020'] === 1,
      groupDel: true, // state => state.user.curUserPerAndParks.pers['10030'] && state.user.curUserPerAndParks.pers['10030'] === 1,
      groupView: true // state => state.user.curUserPerAndParks.pers['10010'] && state.user.curUserPerAndParks.pers['10010'] === 1
    })
  },
  methods: {
    ...mapActions([
      'editRootGroup', 'getGroupByParent', 'groupInfo', 'deleteRootGroup', 'getRootParkAndCust',
      'editGroup', 'getGroupPersAndPark', 'getCurrentUserPerAndParkByGroup', 'getPerAndParkByParent', 'getCurrentUserPers',
      'getAllPers'
    ]),
    persChange (val, fPersTypeID) {
      var rows = this.allChildPers.filter((childPer) => { if (childPer.fPersTypeID === fPersTypeID) { return childPer } })
      if (val) {
        rows.forEach((item, index) => {
          item.myChecked = true
        })
      } else {
        rows.forEach((item, index) => {
          item.myChecked = false
        })
      }
    },
    checkChange (val, pitem, fPersTypeID) {
      // this.allPers[index].pers[childIndex].checked = true
      // this.allPers[index].pers[childIndex].checked = !this.allPers[index].pers[childIndex].checked
      if (val) {
        var rows = this.allChildPers.filter((childPer) => { if (childPer.fPersTypeID === fPersTypeID) { return childPer } })
        if (rows.filter(item => item.myChecked).length === pitem.pers.length) {
          pitem.allChecked = true
        }
      } else {
        pitem.allChecked = false
      }
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.init()
    },
    handlePage (index) {
      this.pageNo = index
      this.init()
    },
    grpQuery () {
      this.init()
    },
    refreshUI () {
      if (this.currentRow !== null && typeof (this.currentRow) !== 'undefined') {
        let param = {}
        param.fGrpID = this.currentRow.fGrpID
        this.getPerAndParkByParent(param).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                let list = []
                Object.assign(list, data.Data.pers)
                this.grpInfoList = list
                let custs = []
                Object.assign(custs, data.Data.bindCusts)
                this.grpParkList = custs
              }
            }
          }
        })
      }
    },
    groupCurrentChange (val) {
      if (val !== null && typeof (val) !== 'undefined') {
        this.currentRow = val
      }
    },
    init () {
      this.form.fPGrpID = this.$route.query.fGrpID
      this.form.fLevel = 1
      let param = {}
      param.fPGrpID = this.$route.query.fGrpID
      param.fGrpName = this.fGrpNameQuery
      param.pageSize = this.pageSize
      param.pageNo = this.pageNo
      param.fLevel = this.form.fLevel
      this.getGroupByParent(param).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              this.groupList = data.Data.rows
              if (this.groupList && this.groupList.length > 0) {
                this.currentRow = this.groupList[0]
              }
            }
          }
        }
      })
    },
    setCheckDefault () {
      for (let i = 0; i < this.allChildPers.length; i++) {
        this.allChildPers[i].myChecked = false
      }
      for (let i = 0; i < this.allPers.length; i++) {
        this.allPers[i].allChecked = false
      }
      this.form.bindCusts = []
      this.form.bindCustsUI = []
    },
    bindQuery () {
      let tmp = this.bindQueryInput.trim()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        let list = []
        Object.assign(list, this.form.bindCustsUI)
        this.form.bindCusts = list
        return
      }
      var newBindQuery = []
      for (let i = 0; i < this.form.bindCustsUI.length; i++) {
        let unionName = this.form.bindCustsUI[i].unionName
        if (unionName.indexOf(tmp) > -1) {
          newBindQuery.push(this.form.bindCustsUI[i])
        }
      }
      this.form.bindCusts = newBindQuery
    },
    unbindQuery () {
      let tmp = this.unbindQueryInput.trim()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        let list = []
        Object.assign(list, this.unbindCustsUI)
        this.unbindCusts = list
        return
      }
      var newUnBindQuery = []
      for (let i = 0; i < this.unbindCustsUI.length; i++) {
        let unionName = this.unbindCustsUI[i].unionName
        if (unionName.indexOf(tmp) > -1) {
          newUnBindQuery.push(this.unbindCustsUI[i])
        }
      }
      this.unbindCusts = newUnBindQuery
    },
    unbindCustChange (cust) {
      this.rightCust = cust
    },
    bindParkChange (cust) {
      this.leftCust = cust
    },
    leftAllBtnClick () {
      if (this.unbindCusts && this.unbindCusts.length > 0) {
        for (let i = 0; i < this.unbindCusts.length; i++) {
          this.form.bindCusts.push(this.unbindCusts[i])
        }
        this.unbindCusts.splice(0, this.unbindCusts.length)
      }
    },
    leftBtnClick () {
      if (!this.rightCust || !this.rightCust.fCustID) {
        return
      }
      this.form.bindCusts.push(this.rightCust)
      this.form.bindCustsUI.push(this.rightCust)
      let index = -1
      for (let i = 0; i < this.unbindCusts.length; i++) {
        if (this.rightCust.fCustID === this.unbindCusts[i].fCustID) {
          index = i
        }
      }
      if (index > -1) {
        this.unbindCusts.splice(index, 1)
        this.unbindCustsUI.splice(index, 1)
      }
    },
    rightBtnClick () {
      if (!this.leftCust || !this.leftCust.fCustID) {
        return
      }
      this.unbindCusts.push(this.leftCust)
      this.unbindCustsUI.push(this.leftCust)
      let index = 0
      for (let i = 0; i < this.form.bindCusts.length; i++) {
        if (this.leftCust.fCustID === this.form.bindCusts[i].fCustID) {
          index = i
        }
      }
      if (index > -1) {
        this.form.bindCusts.splice(index, 1)
        this.form.bindCustsUI.slice(index, 1)
      }
    },
    rightAllBtnClick () {
      if (this.form.bindCusts && this.form.bindCusts.length > 0) {
        for (let i = 0; i < this.form.bindCusts.length; i++) {
          this.unbindCusts.push(this.form.bindCusts[i])
        }
        this.form.bindCusts.splice(0, this.form.bindCusts.length)
      }
    },
    openFun (formName) {
      this.$nextTick(() => {
        if (this.$refs[formName]) {
          this.$refs[formName].resetFields()
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.form.bindCusts = this.form.bindCustsUI
          this.form.pers = this.allChildPers.filter(item => item.myChecked)
          this.editGroup(this.form).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status !== 200) {
                this.$message({
                  type: 'success',
                  message: '分组操作出错'
                })
              } else {
                if (!data.IsOk) {
                  this.$message.error(data.Msg)
                } else {
                  this.init()
                  this.groupInfo()
                  this.dialogFormVisible = false
                }
              }
            }
          })
        } else {
          console.log('userRootGroupMain error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    groupAction () {
      this.dialogFormVisible = true
    },
    viewGroup (index, info) {
      this.form.operateFlag = 'view'
      this.isEdit = false
      this.canEditGrpNo = false
      let fIsAllCust = info.fIsAllCust
      if (fIsAllCust === '1') {
        this.$alert('不能查看管理员组', '查看分组', {
          confirmButtonText: '确定'
        })
        return
      }
      this.updateGroup(index, info)
    },
    updateGroup (index, info) {
      this.canEditGrpNo = false
      // if (info.fCustNum && parseInt(info.fCustNum) > 0) {
      //   this.canEditGrpNo = false
      // }
      this.setCheckDefault()
      if (this.$refs['rootEditform']) {
        this.$refs['rootEditform'].resetFields()
      }
      Object.assign(this.form, info)
      this.getRootParkAndCust({}).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.unbindCusts, data.Data)
            Object.assign(this.unbindCustsUI, data.Data)
            this.getGroupPersAndPark(info).then(res => {
              if (res && res.data) {
                let { status, data } = res
                if (status === 200) {
                  if (data.IsOk) {
                    var persList = data.Data.pers || []
                    for (var i = 0; i < this.allPers.length; i++) {
                      var childPers = this.allChildPers.filter((childPer) => { if (childPer.fPersTypeID === this.allPers[i].fPersTypeID) { return childPer } })
                      var pers = persList.filter(item => { if (item.fPersTypeID === this.allPers[i].fPersTypeID) { return item } })
                      if (pers.length === childPers.length) {
                        this.allPers[i].allChecked = true
                      }
                      for (var j = 0; j < pers.length; j++) {
                        for (var k = 0; k < childPers.length; k++) {
                          if (pers[j].fPersID === childPers[k].fPersID) {
                            childPers[k].myChecked = true
                            break
                          }
                        }
                      }
                    }
                    Object.assign(this.form, res.data.Data)
                    this.form.fGrpName = info.fGrpName
                    this.form.fGrpID = info.fGrpID
                    // this.form.operateFlag = 'edit'
                    this.form.bindCustsUI = Object.assign([], this.form.bindCusts)
                    let delIndex = []
                    for (let i = 0; i < data.Data.bindCusts.length; i++) {
                      for (let j = 0; j < this.unbindCusts.length; j++) {
                        if (data.Data.bindCusts[i]['fCustID'] === this.unbindCusts[j]['fCustID']) {
                          let index = delIndex.findIndex((value) => value === this.unbindCusts[j]['fCustID'])
                          if (index < 0) {
                            delIndex.push(this.unbindCusts[j]['fCustID'])
                          }
                        }
                      }
                    }
                    let newbindPark = []
                    for (let m = 0; m < this.unbindCusts.length; m++) {
                      let index = delIndex.findIndex((value) => value === this.unbindCusts[m]['fCustID'])
                      if (index < 0) {
                        newbindPark.push(Object.assign({}, this.unbindCusts[m]))
                      }
                    }
                    this.unbindCusts = Object.assign([], newbindPark)
                    this.unbindCustsUI = Object.assign([], newbindPark)
                    this.groupAction()
                  }
                }
              }
            })
          }
        }
      })
    },
    addGroup () {
      if (this.$refs['rootEditform']) {
        this.$refs['rootEditform'].resetFields()
      }
      this.isEdit = true
      this.canEditGrpNo = true
      this.form.operateFlag = 'add'
      this.form.fGrpNo = ''
      this.form.fGrpName = ''
      this.setCheckDefault()
      this.getRootParkAndCust({}).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let bind = []
              let bindUI = []
              Object.assign(bind, data.Data)
              Object.assign(bindUI, data.Data)
              this.unbindCusts = bind
              this.unbindCustsUI = bindUI
              this.groupAction()
            }
          }
        }
      })
    },
    editUIGroup (index, info) {
      let fIsAllCust = info.fIsAllCust
      if (fIsAllCust === '1') {
        this.$alert('管理员组不能编辑', '编辑分组', {
          confirmButtonText: '确定'
        })
        return
      }
      this.form.operateFlag = 'edit'
      this.isEdit = true
      this.updateGroup(index, info)
    },
    deleteGroup (index, info) {
      let fIsAllCust = info.fIsAllCust
      if (fIsAllCust === '1') {
        this.$alert('管理员组不能删除', '删除分组', {
          confirmButtonText: '确定'
        })
        return
      }
      let param = {}
      param['fGrpID'] = info.fGrpID
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRootGroup(param).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.init()
                this.groupInfo()
              }
            }
          }
        })
      })
    },
    existsPerGroupIdx (fPersIdx) {
      for (let index = 0; index < this.perGroup.length; index++) {
        if (this.perGroup[index].fPersIdx === fPersIdx) {
          return true
        }
      }
      return false
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 10000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_bind = data.Data.data.is_bind
            this.is_reset = data.Data.data.is_reset
            this.is_admin = data.Data.is_admin
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      let clientHeight = sizethis.getRJPageSize.getRJPageSize()[3] - 250
      sizethis.groupListheight = (clientHeight / 3)
      sizethis.childTableHeight = (clientHeight / 3) * 2
    }
    this.init()
    this.getRootParkAndCust({}).then(res => {
      let { status, data } = res
      if (status === 200) {
        if (data.IsOk) {
          let bind = []
          let bindUI = []
          Object.assign(bind, data.Data)
          Object.assign(bindUI, data.Data)
          this.unbindCusts = bind
          this.unbindCustsUI = bindUI
        }
      }
    })
    this.allPers = []
    this.perGroup = []
    this.getAllPers().then(res => {
      let { status, data } = res
      if (status === 200) {
        if (data.IsOk) {
          for (let i = 0; i < data.Data.length; i++) {
            let tmp = {}
            Object.assign(tmp, data.Data[i])
            if (!this.existsPerGroupIdx(tmp.fPersIdx)) {
              switch (tmp.fPersIdx) {
                case '-1':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '首页管理' })
                  break
                case '0':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '数据看板' })
                  break
                case '1':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '封闭式数据中心' })
                  break
                case '2':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '优惠卷管理' })
                  break
                case '3':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '费率管理' })
                  break
                case '4':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '月卡管理' })
                  break
                case '5':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '封闭式场库管理' })
                  break
                case '6':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '路侧场库管理' })
                  break
                case '7':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '分组管理' })
                  break
                case '8':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '客户管理' })
                  break
                case '9':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '支付宝场库管理' })
                  break
                case '10':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: 'ISV注册管理' })
                  break
                case '11':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '路侧数据中心' })
                  break
                case '12':
                  this.perGroup.push({ fPersIdx: tmp.fPersIdx, name: '设备管理' })
                  break
              }
            }
            tmp.allChecked = false
            for (let j = 0; j < data.Data[i]['pers'].length; j++) {
              let childTmp = {}
              Object.assign(childTmp, data.Data[i]['pers'][j])
              this.$set(childTmp, 'myChecked', data.Data[i]['pers'][j].checked)
              this.allChildPers.push(childTmp)
            }
            this.allPers.push(tmp)
          }
        }
      }
    })
  },
  updated () {
    let clientHeight = this.getRJPageSize.getRJPageSize()[3] - 25 - 250
    this.groupListheight = (clientHeight / 3)
    this.childTableHeight = (clientHeight / 3) * 2
  }
}
</script>
<style>
#userRootGroupMain .el-input.is-disabled .el-input__inner,
#userRootGroupMain .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#userRootGroupMain .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
#userRootGroupMain
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
#userRootGroupMain .el-checkbox {
  padding-bottom: 5px;
}
#userRootGroupMain .check-group {
  padding-bottom: 10px;
}
#userRootGroupMain fieldset .check-group:last-child {
  padding-bottom: 0px;
}
#userRootGroupMain fieldset {
  border: 1px solid #ccc;
}
.rootGroupEdit .el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-family: 微软雅黑;
  font-size: 13px;
  padding-top: 0px;
}
.rootGroupEdit .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.rootGroupEdit .el-dialog__title {
  color: white;
}
.rootGroupEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.rootGroupEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
#userRootGroupMain .rootGroupEdit .el-tabs__content {
  height: 400px;
  overflow: auto;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/user/userRootGroupMain.vue